// Default Keymappings for use within the AppView component

const keyMap = {
    "ctrl+alt+x": [
        {
            action: "FormContainer.action.cancel",
            description: "Cancel Workitem"
        },
        {
            action: "QueryList.clear",
            description: "Clear Criteria"
        }
    ],
    "ctrl+alt+r": [{
        action: "FormContainer.action.routeTo",
        description: "Route To"
    }],
    "ctrl+alt+c": [{
        action: "FormContainer.action.complete",
        description: "Complete Workitem"
    }],
    "ctrl+alt+j": [{
        action: "ImageViewer.scaleFitWidth",
        description: "Image Fit Width"
    }],
    "ctrl+alt+h": [{
        action: "ImageViewer.panLeft",
        description: "Image Pan Left"
    }],
    "ctrl+alt+[": [{
        action: "ImageViewer.rotateCounterClockwise",
        description: "Image Rotate CCW"
    }],
    "ctrl+alt+]": [{
        action: "ImageViewer.rotateClockwise",
        description: "Image Rotate CW"
    }],
    "ctrl+alt+k": [{
        action: "ImageViewer.panRight", 
        description: "Image Pan Right"
    }],
    "ctrl+alt+u": [{
        action: "ImageViewer.panUp",
        description: "Image Pan Up"
    }],
    "ctrl+alt+m": [{
        action: "ImageViewer.panDown",
        description: "Image Pan Down"
    }],
    "ctrl+alt+=": [{
        action: "ImageViewer.zoomIn",
        description: "Zoom In"
    }],
    "ctrl+alt+-": [{
        action: "ImageViewer.zoomOut",
        description: "Zoom Out"
    }],
    "ctrl+alt+.": [{
        action: "ImageViewer.nextPage",
        description: "Image Next Page"
    }],
    "ctrl+alt+,": [{
        action: "ImageViewer.previousPage",
        description: "Image Previous Page"
    }]
}

export { keyMap as defaultKeyMap };
